import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function EventExcuseObservable(testEventID: number, testDetailID: string, generateReplacement: boolean, comment: string, excuseReasonCode:string, excuseComment:string): Observable<string> {
  const params: string = JSON.stringify({
      TestDetailID: testDetailID,
      TestEventID: testEventID,
      GenerateReplacement:generateReplacement,
      SchedulingNotes: comment,
      ExcuseReasonCode:excuseReasonCode,
      ExcuseComment:excuseComment
  })

  return ObservableFromFetch<string>("FFOrderPoolDefinition/ExcuseAnEvent", params)
}

export function CanSubstituteOnExcuseObservable( testDetailID: string) {
  const requestBody: string = new URLSearchParams({
    TestDetailID: testDetailID
  }).toString()

  return ObservableFromFetch<boolean>("FFOrderPoolDefinition/CanSubstituteOnExcuse?" + requestBody)
}

export function GetExcuseNotesObservable( testDetailID: string) {
  const params: string = JSON.stringify({
    TestDetailID: testDetailID
  })

  return ObservableFromFetch<string>("FFOrderPoolDefinition/GetSchedulingNote", params)
}

export function UpdateExcuseNotesObservable( testDetailID: string, comment: string) {
  const params: string = JSON.stringify({
    TestDetailID: testDetailID,
    SchedulingNotes: comment
  })

  return ObservableFromFetch<string>("FFOrderPoolDefinition/UpdateSchedulingNote", params)
}

export function EventUnexcuseObservable(testEventID: number, testDetailID: string) {
  const params: string = JSON.stringify({
    TestDetailID: testDetailID,
    TestEventID: testEventID
  })

  return ObservableFromFetch<string>("FFOrderPoolDefinition/UnexcuseAnEvent", params)
}


